<script lang="tsx">
  import {
    defineComponent, PropType,
    computed,
  } from 'vue'
  import BeerButton from '@xhs/yam-beer/cmp/common/Button/Button.vue'
  import { BeerStyleObj } from '../../../core'

  export default defineComponent({
    name: 'Pager',
    props: {
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      iconBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      isActive: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String,
        required: false,
      },
    },
    setup(props, { attrs, slots }) {
      const mergedBs = computed(() => {
        const bs: BeerStyleObj = {
          py: 5,
          mr: 6,
          minWidth: 28,
          bg: props.disabled ? 'transparent' : undefined,
          ...props.bs,
        }
        return bs
      })

      const variant = computed(() => (props.isActive ? 'default' : 'text'))
      const modifier = computed(() => (props.isActive ? 'primary' : 'mute'))

      return () => {
        if (props.icon) {
          return (
          <BeerButton
            iconBs={{
              mr: 0,
              ...props.iconBs,
            }}
            size="nm"
            variant={variant.value}
            modifier={modifier.value}
            bs={mergedBs.value}
            disabled={props.disabled}
            icon={props.icon}
            {...attrs}
          />
        )
        }
        return (
        <BeerButton
          size="nm"
          variant={variant.value}
          modifier={modifier.value}
          bs={mergedBs.value}
          disabled={props.disabled}
          {...attrs}
        >
          {slots.default?.()}
        </BeerButton>
      )
      }
    },
  })
</script>
